import { JSX } from 'react';
import './dateTitleBar.css';

const DateTitleBar = () : JSX.Element => {
    return (
        <div className='date-title-bar-container'>
            <p>Sun</p>
            {/* <div className='divider'/> */}
            <p>Mon</p>
            {/* <div className='divider'/> */}
            <p>Tue</p>
            {/* <div className='divider'/> */}
            <p>Wed</p>
            {/* <div className='divider'/> */}
            <p>Thu</p>
            {/* <div className='divider'/> */}
            <p>Fri</p>
            {/* <div className='divider'/> */}
            <p>Sat</p>
        </div>
    )
}

export default DateTitleBar;